<template>
    <div class="mb-2">
        <img ref="image" :src="selected.url | baseurl" style="max-width: 100%">
        <div class="text-center p-2">
            <div class="d-inline rounded bg-dark text-white px-2 py-1">
                <span class="text-secondary">x:</span> {{ x }}px
                <span class="text-secondary ml-2">y:</span> {{ y }}px
                <span class="text-secondary ml-2">width:</span> {{ width }}px
                <span class="text-secondary ml-2">height:</span> {{ height }}px
            </div>
        </div>
    </div>
</template>

<script>
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
    name: 'filemanager-cropper',
    props: {
        'enabled': {
            type: Boolean,
            required: true
        },
        'selected': {
            required: true
        }
    },
    data: function()
    {
        return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    },
    mounted()
    {
        this.cropper = new Cropper(this.$refs.image, {
            viewMode: 2,
            responsive: true,
            background: false,
            zoomable: false,
            ready: this.changed,
            cropend: this.changed
        });
    },
    methods: {
        changed()
        {
            let data = this.cropper.getData(true);

            this.x = data.x;
            this.y = data.y;
            this.width = data.width;
            this.height = data.height;

            this.$events.$emit('filemanager-crop-changed', {
                x: this.x,
                y: this.y,
                width: this.width,
                height: this.height
            });
        }
    }
};
</script>

<style>
.cropper-modal {
    background-color: transparent !important;
}
</style>
